var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { GET_INVOICES_SUCCESS } from './invoices.action';
export var initialState = {
    list: {
        data: [],
        total: 0
    }
};
export function invoicesReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_INVOICES_SUCCESS:
            var data = action.payload;
            return __assign({}, state, { list: {
                    data: data,
                    total: data.length
                } });
        default: {
            return state;
        }
    }
}
export var getList = function (state) { return state.list.data; };
export var getListTotal = function (state) { return state.list.total; };
export var getMainInvoiceSelector = function (state) { return state.billing.invoices; };
export var getInvoicesListSelector = createSelector(getMainInvoiceSelector, getList);
export var getInvoicesTotalSelector = createSelector(getMainInvoiceSelector, getListTotal);
